import React from 'react'
import styled from 'styled-components'
import { DefaultInput } from '../elements'

const ContainerElement = styled.div`
  display: grid;
  width: 250px;
  align-items: center;
  grid-template-columns: 90% 1fr;
  grid-template-rows: 1fr;
  gap: 8px;
`

const ButtonElement = styled.button`
  background: none;
  border: none;
  width: fit-content;
  padding: 4px;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  &:hover {
    opacity: 0.6;
  }
`

const TrashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 485 485"
    fill="gray"
    {...props}
  >
    <path d="M67.224 0h350.535v71.81H67.224zM417.776 92.829H67.237V485h350.537V92.829h.002zM165.402 431.447H137.04V146.383h28.362v285.064zm91.287 0h-28.363V146.383h28.363v285.064zm91.281 0h-28.361V146.383h28.361v285.064z" />
  </svg>
)

function AffiliateCard({ id, value, deletable, onDelete, handleChange }) {
  const onBlur = (e) => {
    const newValue = e.target.value.trim()
    if (newValue === value) return

    handleChange({ id, name: newValue })
  }

  return (
    <ContainerElement>
      <DefaultInput value={value} onBlur={onBlur} />
      {deletable && (
        <ButtonElement onClick={onDelete}>
          <TrashIcon />
        </ButtonElement>
      )}
    </ContainerElement>
  )
}

export default AffiliateCard
